module.exports = __webpack_public_path__ + "static/media/coverage-map-scr.52000d7b.png";